(function ($) {
	$.fn.ddSelect = function (opts) {
		var $dd = this.filter('select'),
			listen = $dd.data('ddselect-listen'),
			$form = $dd.parents('form'),
			settings = $.extend({}, opts),
			setList = function($select, raw) {
				var $items = [];
				var a = raw.split(';');
				$.each(a, function(key, item) {
					var tmp = item.split('=');
					if (tmp.length === 2) {
						$items.push($('<option>', {value: tmp[0]}).text(tmp[1]));
					}
				});
				if ($items.length > 0) {
					$select.empty().append($items);
					$select.trigger('change');
					$select.trigger('ddSelectChange');
				}
			}
		;
		if (settings.ddSelectChange) {
			$dd.on('ddSelectChange', settings.ddSelectChange);
		}
		$form.find(listen).change(function() {
			var $this = $(this);
			var value = $this.val();
			if (value) {
				var key = 'ddselect-' + value;
				var raw = $dd.data(key);
				if (raw) {
					setList($dd, raw);
				}
			}
		}).trigger('change');
	};
}(jQuery));
